import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth/auth.service";


@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

    constructor(private authService: AuthService) { }

    loggedIn: boolean = false;

    ngOnInit() {
        this.loggedIn = this.authService.isAuthenticated();
    }

}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/anon/welcome.component.ts